import { FunctionComponent } from 'react'

export const DefaultErrorWrapper: FunctionComponent = ({ children: errorMessage }) => {
  return <div>Unfortunately error appeared: {errorMessage}</div>
}
